import { missionDiaryConstant } from '../constant';

function isMissionDiaryEnabled(settings) {
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.GET_IS_ENABLED, payload: settings });
    };
}

function isManualSequenceEnabled(settings) {
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.GET_IS_MANUAL_SEQUENCE_ENABLED, payload: settings });
    };
}

function getMissionDiaryRecords(settings, totalCount) {
    const missionDiary = settings;
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.GET_RECORDS, payload: { missionDiary, totalCount } });
    };
}

function getMissionDiaryUpdatedDateTime(settings) {
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.GET_UPDATED_DATETIME, payload: settings });
    };
}

function isMissionDiaryCheckInEnabled(settings) {
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.CHECK_DAILY_CHECKIN_IS_ENABLED, payload: settings });
    };
}

function setMissionDairyStatus(data) {
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.GET_MEMBER_MISSION_STATUS, payload: data });
    };
}

function setMissionCheckinRecord(data) {
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.GET_MEMBER_MISSION_RECORD, payload: data });
    };
}

function closeDailyCheckInPopup(isClosed = false) {
    return (dispatch) => {
        dispatch({ type: missionDiaryConstant.CLOSE_DAILY_CHECKIN_POPUP, payload: isClosed });
    };
}


export const missionDiaryAction = {
    isMissionDiaryEnabled,
    getMissionDiaryRecords,
    getMissionDiaryUpdatedDateTime,
    isManualSequenceEnabled,
    isMissionDiaryCheckInEnabled,
    setMissionDairyStatus,
    setMissionCheckinRecord,
    closeDailyCheckInPopup

};
